import React, { Component } from "react";
import mainImage from "../../assests/images/13.jpg";

export default class ProjectsImg extends Component {
  render() {
    return <img src={mainImage} alt="Feeling Proud" />;
  }
}
